<template>
  <div id="exchanges" style="height:100%;">
    <div class="box" :class="{ enRealTimeTransCC: isEnRealTimeTransCC }">
      <div class="maintrans">
        <!-- <div @click="reStart">ceshi1</div> -->
        <!-- 交易 -->
        <!-- <ul v-show="tradeType=='x'" class="content"> -->
        <ul class="content">
          <!-- 买入 -->
          <li v-show="buyOrSell == 'buy'" id="middleMargin" class="left">
            <div class="transcc_new_NewFooter_left_top" :style="tradeViewStyle">
              <div class="transcc_new_NewFooter_left--left">
                <slot name="left"/>
                <ul class="price flex-price-box">
                  <li class="message">
                    <span
                      style="font-size:14px;color:#dfdfdf;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-right: 10px;"
                    >买价</span>
                    <input
                      ref="prices"
                      v-model="price"
                      step="0.01"
                      class="sty"
                      type="number"
                      onmousewheel="return false;"
                      @input="limitBuyPrice"
                      @keyup.enter="shortcuts_F2()"
                      @keydown="channelInputLimitPrice"
                    >
                    <span></span>
                    <span style="display:none">{{
                      Number(prices).toFixed(2)
                    }}</span>
                    <span
                      style="position:absolute;top:10px;right:20px;color:rgba(255, 255, 255, 0.4);"
                    >{{ units }}</span>
                    <div class="pricebtns">
                      <i
                        class="el-icon-caret-top pricebtn"
                        @click="pricebtnbClick('up')"
                      />
                      <i
                        class="el-icon-caret-bottom pricebtn"
                        @click="pricebtnbClick('down')"
                      />
                    </div>
                  </li>
                  <li class="message" style="marginBottom:0;">
                    <span
                      style="font-size:14px;color:#DFDFDF;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-right: 10px;"
                    >买量</span>
                    <input
                      ref="num"
                      v-model="num"
                      step="0.01"
                      class="sty"
                      onmousewheel="return false;"
                      type="number"
                      @input="limitBuyNumber"
                      @keyup.enter="transBuybefore()"
                      @keydown="channelInputLimitNum"
                    >
                    <div class="numbtns">
                      <i
                        class="el-icon-caret-top numbtn"
                        @click="numbuyClick('up')"
                      />
                      <i
                        class="el-icon-caret-bottom numbtn"
                        @click="numbuyClick('down')"
                      />
                    </div>
                    <!-- <span style="position:absolute;top:10px;right:20px;color:rgba(255, 255, 255, 0.4);">{{ unit }}</span> -->
                  </li>
                </ul>
              </div>
               <div class="transcc_new_NewFooter_left--right">
                <slot name="right"></slot>
              </div>
            </div>
            <div class="transcc_new_NewFooter_left_bottom">
              <div class="message topSelectChange buyBgc">
                <el-radio-group v-model="selectTop">
                  <el-radio :label="0">销售①</el-radio>
                  <el-radio :label="1">销售②</el-radio>
                  <el-radio :label="2">销售③</el-radio>
                </el-radio-group>
              </div>
              <div class="buyStep">
                <el-slider
                  v-model="value1"
                  show-stops=""
                  :format-tooltip="formatTooltip"
                  :disabled="disable"
                  :step="20"
                  :marks="marks"
                  @change="buyAmountset"
                >
                </el-slider>
              </div>
              <ul class="sum">
                <li class="message">
                  <span class="priceText">最大下单量：</span>
                  <span class="priceNum">{{ canBuy }} {{ units }}</span>
                </li>
                <li class="message" style="justify-content:flex-end">
                  <span class="priceText">订金：</span>
                  <span
                    class="priceNum"
                  >{{
                    isNaN(price * num)
                      ? '--'
                      : (selectCommodityStrategy.marginType == '1'
                        ? num *
                          selectCommodityStrategy.margin *
                          selectCommodityStrategy.unitNumeral
                        : price *
                          num *
                          selectCommodityStrategy.margin *
                          selectCommodityStrategy.unitNumeral
                      ).toFixed(2)
                  }}
                    {{ units }}</span>
                </li>
              </ul>
              <div>
                <input
                  type="button"
                  class="btn"
                  value="买入订立"
                  :disabled="yesNo"
                  @click="transBuy()"
                >
              </div>
              <div class="cotract">
                <el-checkbox v-model="isCheckHt"> </el-checkbox>&nbsp;我已同意签署<span
                  @click="aggreementShow(1)"
                  style=" cursor: pointer;"
                >《订单商品销售协议》</span>
              </div>
            </div>
          </li>
          <!-- 卖出 -->
          <li v-show="buyOrSell == 'sell'" class="left">
            <div class="transcc_new_NewFooter_left_top" :style="tradeViewStyle">
              <div class="transcc_new_NewFooter_left--left">
                <slot name="left"/>
                <ul class="price flex-price-box">
                  <li class="message">
                    <span
                      style="font-size:14px;color:#dfdfdf;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-right: 10px;"
                    >卖价</span>
                    <input
                      ref="sellprices"
                      v-model="sell"
                      step="0.01"
                      class="sty"
                      onmousewheel="return false;"
                      type="number"
                      @input="limitSellPrice"
                      @keyup.enter="shortcuts_F4()"
                      @keydown="channelInputLimitPrice"
                    >
                    <span style="display:none">{{ sells }}</span>
                    <span
                      style="position:absolute;top:10px;right:20px;color:rgba(255, 255, 255, 0.4);"
                    >{{ units }}</span>
                    <div class="pricebtns">
                      <i
                        class="el-icon-caret-top pricebtn"
                        @click="pricebtnClick('up')"
                      />
                      <i
                        class="el-icon-caret-bottom pricebtn"
                        @click="pricebtnClick('down')"
                      />
                    </div>
                  </li>
                  <li class="message" style="marginBottom:0;">
                    <span
                      style="font-size:14px;color:#dfdfdf;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-right: 10px;"
                    >卖量</span>
                    <input
                      ref="sellnum"
                      v-model="number"
                      step="0.01"
                      class="sty"
                      onmousewheel="return false;"
                      type="number"
                      @input="limitSellNumber"
                      @keyup.enter="transSellbefore()"
                      @keydown="channelInputLimitNum"
                    >
                    <div class="numbtns">
                      <i
                        class="el-icon-caret-top numbtn"
                        @click="numsellClick('up')"
                      />
                      <i
                        class="el-icon-caret-bottom numbtn"
                        @click="numsellClick('down')"
                      />
                    </div>
                    <!-- <span style="position:absolute;top:10px;right:20px;color:rgba(255, 255, 255, 0.4);">{{ unit }}</span> -->
                  </li>
                </ul>
             </div>
              <div class="transcc_new_NewFooter_left--right">
                <slot name="right"></slot>
              </div>
            </div>
            <div class="transcc_new_NewFooter_left_bottom">
                <div class="message topSelectChange sellBgc">
              <el-radio-group v-model="selectTop">
                <el-radio :label="0">采购①</el-radio>
                <el-radio :label="1">采购②</el-radio>
                <el-radio :label="2">采购③</el-radio>
              </el-radio-group>
            </div>
            <div class="tradStep">
              <el-slider
                v-model="value2"
                show-stops
                :format-tooltip="formatTooltip"
                :step="20"
                 :marks="marks"
                @change="sellAmountset"
              >
              </el-slider>
            </div>
            <ul class="sum">
              <li class="message">
                <span class="priceText">最大下单量：</span>
                <span class="priceNum">{{ canSell }} {{ units }}</span>
              </li>
              <li class="message" style="justify-content:flex-end">
                <span class="priceText">订金：</span>
                <span
                  class="priceNum"
                >{{
                   isNaN(sell * number)
                     ? '--'
                     : (selectCommodityStrategy.sellMarginType == '1'
                       ? number *
                         selectCommodityStrategy.sellMargin *
                         selectCommodityStrategy.unitNumeral
                       : sell *
                         number *
                         selectCommodityStrategy.sellMargin *
                         selectCommodityStrategy.unitNumeral
                     ).toFixed(2)
                 }}
                  {{ units }}</span>
              </li>
            </ul>
            <div v-if="sessionInfoGetter.isLogin == 'true'">
              <input
                type="button"
                class="btn"
                value="卖出订立"
                :disabled="yesNo2"
                onkeyup="this.value=this.value.replace(/^\d+\.?\d{0,2}$/)"
                @click="transSell()"
              >
            </div>
            <div class="cotract">
              <el-checkbox v-model="isCheckHt"> </el-checkbox>&nbsp;我已同意签署<span @click="aggreementShow(2)" style=" cursor: pointer;">《订单商品销售协议》</span>
            </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <span style="display:none">{{ data }}</span>
    <!-- dialog 快捷平仓 -->
    <el-dialog
      title="快捷撤单"
      :visible.sync="dialogDiscover"
      class="stop-profit-loss"
    >
      <el-row class="zr_dialog_input">
        <el-col :span="6"><div style="line-height:40px">最低价格</div></el-col>
        <el-col :span="18">
          <el-input
            ref="dialog_lowPrice"
            v-model="transfer.lowPrice"
            type="number"
            placeholder="最低价格"
            @keyup.enter.native="lowPriceEnter"
          ></el-input>
        </el-col>
      </el-row>
      <el-row class="zr_dialog_input">
        <el-col :span="6"><div style="line-height:40px">最高价格</div></el-col>
        <el-col :span="18">
          <el-input
            ref="dialog_highPrice"
            v-model="transfer.highPrice"
            type="number"
            :disabled="disablePC"
            placeholder="最高价格"
            @keyup.enter.native="tackAndLossConfirm"
          ></el-input>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button class="el-cancel-btn" @click="dialogDiscover = false">取消</el-button>
        <el-button
          type="primary"
          class="el-confirm-btn"
          :disabled="disablePC"
          @click="tackAndLossConfirm"
        >确定</el-button>
      </div>
    </el-dialog>
    <!-- dialog 买卖合同 -->
    <el-dialog
      id="gsHt"
      title="合同"
      :before-close="handleClose1"
      :visible.sync="dialogDiscoverHt"
    >
      <el-row class="zr_dialog_input">
        <el-col :span="22">
          <HtMessage
            :bs-flag="htBsflag"
            :price="htPrice"
            :amount="htAmount"
            :transaction-volume="htTransactionVolume"
          ></HtMessage>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button class="el-cancel-btn" @click="dialogDiscoverHt = false">我不能接受</el-button> -->
        <el-button
          id="btns"
          type="primary"
          class="el-confirm-btn"
          :disabled="disableHt"
          @click="htSuccess"
        >{{ btnText }}</el-button>
      </div>
    </el-dialog>
    <!-- 是否查看风险协议弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      style="height: 45%"
      :before-close="handleClose"
    >
      <div v-if="!agreementFlag" class="protol_top">
        <div class="pt_title">是否查看协议</div>
        <div class="dialog_footer">
          <el-button @click="cancelClick">取 消</el-button>
          <el-button type="primary" @click="enterClick">确 定</el-button>
        </div>
      </div>
      <div v-else class="protol_bottom">
        <div class="pb_title">加载中...</div>
        <el-progress :percentage="percentageNum" :format="format"></el-progress>
      </div>
    </el-dialog>
    <confirmDialog
      ref="confirmDialog"
      title="是否查看协议"
      @reLoad="confirmAggreement"
    />
    <confirmDialog
      ref="transBuyDialog"
      title="是否确认买入订立"
      @reLoad="transBuyControl"
    />
    <confirmDialog
      ref="transSellDialog"
      title="是否确认卖出订立"
      @reLoad="transSellControl"
    />
    <hint-dialog ref="hintDialog" @reLoad="confirmHint" />
    <aggreement-dialog ref="aggreementDialog" @reLoad="aggreementOk" />
  </div>
</template>
<script>
/* global hqProtocol hqWs protocol http util*/
import { mapGetters } from 'vuex'
import HtMessage from './HtMessage'
import confirmDialog from '../../../components/base/dialog/confirmDialog.vue'
import HintDialog from '../../../components/base/dialog/hintDialog.vue'
import aggreementDialog from '../../../components/base/dialog/aggreementDialog.vue'
export default {
  name: 'RealTimeTransCC',
  components: {
    HtMessage,
    confirmDialog,
    HintDialog,
    aggreementDialog
  },
  props: {
    buyOrSell: {
      type: String,
      default: ''
    },
    selectTradeType: {
      type: String,
      default: ''
    }
  },
  inject: ['tradeView'],
  data() {
    return {
      marks:{
        0:'0%',
        20:'20%',
        40:'40%',
        60:'60%',
        80:'80%',
        100:'100%'
      },
      isBuy: 1,
      formData: {},
      selectTop: 0, // 0-top1   1-top2   2-top3
      isCheckHt: true, // 是否签署合同
      marketPrice: null, // 如果编辑跳转到限价委托
      timeInterval: null,
      timeText: null,
      btnText: '',
      btnFlag: 1, // 1 买入开多 2 卖出开空
      setIntervalTime: null,
      percentageNum: 0,
      agreementFlag: false,
      dialogVisible: false,
      passwordShow1: false,
      radio: 0,
      isChangedDisable: false,
      priceTrue: false,
      TotalMoney: '21.0000003',
      message: '费率',
      isTrue: true,
      isTrueA: false,
      num: '',
      number: '',
      yesNo: false,
      yesNo2: false,
      yesNo3: false,
      yesNo4: false,
      sell: ' ',
      price: '',
      balance1: null,
      balance2: null,
      isEnRealTimeTransCC: false,
      lt1: '',
      lt2: '',
      value1: [0, 10],
      value2: 0,
      disable: false,
      selectGood: false,
      goodName: '',
      goodMemo: '',
      addrCopy: '',
      addr: '',
      dialogChargeVisible: false,
      currentChargeCoin: '',
      // 快捷平仓
      dialogDiscover: false,
      transfer: {
        highPrice: '',
        lowPrice: ''
      },
      disablePC: false,
      tradeType: 'x', // x限价 s市价
      // 合同
      dialogDiscoverHt: false,
      disableHt: false,
      Htjs: null,
      htBsflag: '',
      htPrice: '',
      htAmount: '',
      htTransactionVolume: '',
      // 数量随top变动限制
      numBuylock: false,
      numSelllock: false,
      ordersDialog: false,
    
    }
  },
  computed: {
    ...mapGetters([
      'sessionInfoGetter',
      'item',
      'myassetDataGetter',
      'commodityStrategyGetter',
      'h_avilibleMargin',
      'H_haveAsset',
      'isChangeMarginPsdGetter',
      'verticalityclick',
      'verticalityclick_up',
      'verticalityclick_down'
    ]),
    data() {
      const item = this.$store.state.hqData.item.symbolId
      if (item) {
        return item
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbolId
        } else {
          return '--'
        }
      }
    },
    selectCommodityStrategy() {
      if (this.data !== '--' && this.commodityStrategyGetter.length > 0) {
        for (const CommodityStrategy of this.commodityStrategyGetter) {
          if (this.data == CommodityStrategy.commodityId) {
            return CommodityStrategy
          }
        }
      } else if (this.data == '--' && this.commodityStrategyGetter.length > 0) {
        return this.commodityStrategyGetter[0]
      }
      return {
        canBuy: '0',
        canDqDelivery: '--',
        canSell: '0',
        canShow: '--',
        canTqDelivery: '--',
        canTqTransfer: '--',
        canTransfer: '--',
        commodityCode: '--',
        commodityId: null,
        commodityName: '--',
        feeStrategyId: '--',
        guidePrice: '--',
        holdStrategyId: '--',
        margin: '--',
        marginStrategyId: '--',
        marginType: '--',
        marketPrice: '--',
        maxHoldAmount: '--',
        maxSingleTradeAmount: '--',
        maxUpDownWidth: '--',
        minAmountChange: 0.01,
        minPickupAmount: '--',
        minPriceChange: 0.01,
        minSingleTradeAmount: '--',
        offerEndTime: 0,
        openFee: '--',
        openFeeType: '--',
        pickupCountdown: '--',
        pickupStandard: '--',
        pickupStartTime: 0,
        tradeStrategyId: '--',
        transferFee: '--',
        transferFeeType: '--',
        unitNumeral: '--',
        unitQuantifier: '--',
        sellMargin: '--',
        sellMarginType: '--'
      }
    },
    unit() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        const strDian = item.split('/')
        const strDianQian = strDian[0]
        return strDianQian
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbol.split('/')[0]
        } else {
          return ''
        }
      }
    },
    units() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        const strDian = item.split('/')
        const strDianQian = strDian[1]
        return strDianQian
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbol.split('/')[1]
        } else {
          return ''
        }
      }
    },
    sells() {
      const item = this.$store.state.hqData.item.close
      if (item) {
        return Number(item).toFixed(this.item.coinDigitalNum)
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return Number(
            this.$store.state.hqData.marketDetails[0].close
          ).toFixed(this.item.coinDigitalNum)
        } else {
          return '--'
        }
      }
    },
    prices() {
      const item = this.$store.state.hqData.item.close
      if (item) {
        return Number(item).toFixed(this.item.coinDigitalNum)
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].close
        } else {
          return '--'
        }
      }
    },
    buyLst() {
      const item = this.$store.state.hqData.buyLst
      if (item) {
        return item
      } else {
        return '--'
      }
    },
    sellLst() {
      const item = this.$store.state.hqData.sellLst
      if (item) {
        return item
      } else {
        return '--'
      }
    },
    sellOne() {
      const item = this.$store.state.hqData.sellOne
      if (item) {
        return item
      } else {
        return '--'
      }
    },
    buyOne() {
      const item = this.$store.state.hqData.buyOne
      if (item) {
        return item
      } else {
        return '--'
      }
    },
    /**
     * 保证金比例，手续费比例
     * 最大下单量=当前可用资金/（填入卖出价*卖出保证金比例+填入卖出价*卖出手续费比例）
     * 保证金比例，手续费固定值
     * 最大下单量=当前可用资金/（填入卖出价*卖出保证金比例+卖出手续费固定值）
     * 保证金固定值，手续费比例
     * 最大下单量=当前可用资金/（卖出保证金固定值+填入卖出价*卖出手续费比例）
     * 保证金固定值，手续费固定值
     * 最大下单量=当前可用资金/（卖出保证金固定值+卖出手续费固定值）
     * 算出来的数值向下取整
     */
    canBuy() {
      if (this.balance1 <= 0) {
        return 0
      }
      let num
      // 计算单笔保证金
      let margin = 0 // 假定为0
      if (this.selectCommodityStrategy.marginType == '1') {
        // 固定值
        margin =
          this.selectCommodityStrategy.unitNumeral *
          this.selectCommodityStrategy.margin
      } else {
        margin =
          this.price *
          this.selectCommodityStrategy.unitNumeral *
          this.selectCommodityStrategy.margin
      }
      // 计算单笔手续费 (开仓)
      let fee = 0 // 假定为0
      if (this.selectCommodityStrategy.openFeeType == '1') {
        fee =
          this.selectCommodityStrategy.unitNumeral *
          this.selectCommodityStrategy.openFee
      } else {
        fee =
          this.price *
          this.selectCommodityStrategy.unitNumeral *
          this.selectCommodityStrategy.openFee
      }
      if (margin + fee > 0) {
        num = util.floorFun(
          this.balance1 / (fee + margin),
          this.item.quantityNum
        )
      } else {
        num = '0'
      }
      return num
    },
    canSell() {
      if (this.balance2 <= 0) {
        return 0
      }
      let num
      // 计算单笔保证金 (卖出方向)
      let margin = 0 // 假定为0
      if (this.selectCommodityStrategy.sellMarginType == '1') {
        // 固定值
        margin =
          this.selectCommodityStrategy.unitNumeral *
          this.selectCommodityStrategy.sellMargin
      } else {
        margin =
          this.sell *
          this.selectCommodityStrategy.unitNumeral *
          this.selectCommodityStrategy.sellMargin
      }
      // 计算单笔手续费 (开仓)
      let fee = 0 // 假定为0
      if (this.selectCommodityStrategy.openFeeType == '1') {
        fee =
          this.selectCommodityStrategy.unitNumeral *
          this.selectCommodityStrategy.openFee
      } else {
        fee =
          this.sell *
          this.selectCommodityStrategy.unitNumeral *
          this.selectCommodityStrategy.openFee
      }
      if (margin + fee > 0) {
        num = util.floorFun(
          this.balance2 / (fee + margin),
          this.item.quantityNum
        )
      } else {
        num = '0'
      }
      return num
    },
    // 资产小数点位数(合约)
    coinDigitalNum() {
      return 2
    },
    tradeViewStyle() {
      if(!this.tradeView()){
        return {
          'flex-direction':'row-reverse'
        }
      }else{
        return 
      }
    },
    tradeViewMargin(){
       if(!this.tradeView()){
        return {
         'margin-left':0,
         'margin-right':9+'px'
        }
      }
    }
  },
  watch: {
    buyOrSell() {
      this.selectTop = 0
      // localStorage.setItem('commFormPrice', '')
      // localStorage.setItem('commFormNum', '')
      // localStorage.setItem('commFormDj', '')
      if (this.buyOrSell === 'buy') {
        localStorage.setItem('commFormPrice', this.price)
        localStorage.setItem('commFormNum', this.num)
        this.htTransactionVolume = isNaN(this.price * this.num)
          ? '--'
          : (this.selectCommodityStrategy.marginType == '1'
            ? this.num *
            this.selectCommodityStrategy.margin *
            this.selectCommodityStrategy.unitNumeral
            : this.price *
            this.num *
            this.selectCommodityStrategy.margin *
            this.selectCommodityStrategy.unitNumeral
          ).toFixed(2)
      } else {
        localStorage.setItem('commFormPrice', this.sell)
        localStorage.setItem('commFormNum', this.number)
        this.htTransactionVolume = isNaN(this.sell * this.number)
          ? '--'
          : (this.selectCommodityStrategy.marginType == '1'
            ? this.number *
            this.selectCommodityStrategy.margin *
            this.selectCommodityStrategy.unitNumeral
            : this.sell *
            this.number *
            this.selectCommodityStrategy.margin *
            this.selectCommodityStrategy.unitNumeral
          ).toFixed(2)
      }
      localStorage.setItem('commFormDj', this.htTransactionVolume)
    },
    selectTop() {
      // 切换top选中,解锁数量.价格随top变化限制
      this.emitChangeTypeUnlock()
      setTimeout(() => {
        this.initPrice()
      }, 0)
    },
    item: function(xin, jiu) {
      if (xin.symbolId !== jiu.symbolId) {
        const _this = this
        this.numBuylock = false
        this.numSelllock = false
        setTimeout(() => {
          _this.selectTop = 0
          _this.initPrice()
        }, 500)
      }
    },
    // unit: function() {
    //   if (this.sessionInfoGetter.isLogin == 'true') {
    //     this.creditAvailable()
    //   }
    // },
    // units: function() {
    //   if (this.sessionInfoGetter.isLogin == 'true') {
    //     this.creditAvailable()
    //   }
    // },
    // price(val){
    //   if(!val) return
    //     if(!/^\d*\.?\d{0,2}$/.test(val)){
    //     }
    // }
    buyOne: function(val, oldVal) {
      if (val[0] != '--' && this.selectTradeType == '1') {
        this.emitChangeTypeLock()
        this.sell = Number(val[0]).toFixed(this.item.coinDigitalNum)
      } else {
        this.sell = ''
      }
    },
    sellOne: function(val, oldVal) {
      if (val[0] != '--' && this.selectTradeType == '1') {
        this.emitChangeTypeLock()
        this.price = Number(val[0]).toFixed(
          this.item.coinDigitalNum
        )
      } else {
        this.price = ''
      }
    },
    buyLst() {
      if (window.g.APP_ISAUTOPRICE && this.selectTradeType === '1') {
        this.initPrice()
      }
    },
    sellLst() {
      if (window.g.APP_ISAUTOPRICE && this.selectTradeType === '1') {
        this.initPrice()
      }
    },
    h_avilibleMargin(val, oldVal) {
      if (val) {
        this.balance1 = val
        this.balance2 = val
      }
    },
    dialogDiscoverHt(val, oldVal) {
      if (!val) {
        this.yesNo = false
        this.yesNo2 = false
        this.yesNo3 = false
        this.yesNo4 = false
      }
    },
    verticalityclick() {
      this.shortcuts_verticality() // 切换价格和数量的选中
    },
    verticalityclick_up() {
      this.shortcuts_verticality_up() // 微调价格和数量
    },
    verticalityclick_down() {
      this.shortcuts_verticality_down() // 微调价格和数量
    },
    price(val) {
      if (this.buyOrSell === 'buy') {
        localStorage.setItem('commFormPrice', val)
        this.htTransactionVolume = isNaN(this.price * this.num)
          ? '--'
          : (this.selectCommodityStrategy.marginType == '1'
            ? this.num *
            this.selectCommodityStrategy.margin *
            this.selectCommodityStrategy.unitNumeral
            : this.price *
            this.num *
            this.selectCommodityStrategy.margin *
            this.selectCommodityStrategy.unitNumeral
          ).toFixed(2)
        localStorage.setItem('commFormDj', this.htTransactionVolume)
      }
    },
    sell(val) {
      if (this.buyOrSell === 'sell') {
        localStorage.setItem('commFormPrice', val)
        this.htTransactionVolume = isNaN(this.sell * this.number)
          ? '--'
          : (this.selectCommodityStrategy.marginType == '1'
            ? this.number *
            this.selectCommodityStrategy.margin *
            this.selectCommodityStrategy.unitNumeral
            : this.sell *
            this.number *
            this.selectCommodityStrategy.margin *
            this.selectCommodityStrategy.unitNumeral
          ).toFixed(2)
        localStorage.setItem('commFormDj', this.htTransactionVolume)
      }
    },
    num(val) {
      if (this.buyOrSell === 'buy') {
        localStorage.setItem('commFormNum', this.num)
        this.htTransactionVolume = isNaN(this.price * this.num)
          ? '--'
          : (this.selectCommodityStrategy.marginType == '1'
            ? this.num *
            this.selectCommodityStrategy.margin *
            this.selectCommodityStrategy.unitNumeral
            : this.price *
            this.num *
            this.selectCommodityStrategy.margin *
            this.selectCommodityStrategy.unitNumeral
          ).toFixed(2)
        localStorage.setItem('commFormDj', this.htTransactionVolume)
      }
    },
    number(val) {
      if (this.buyOrSell === 'sell') {
        localStorage.setItem('commFormNum', this.number)
        this.htTransactionVolume = isNaN(this.sell * this.number)
          ? '--'
          : (this.selectCommodityStrategy.marginType == '1'
            ? this.number *
            this.selectCommodityStrategy.margin *
            this.selectCommodityStrategy.unitNumeral
            : this.sell *
            this.number *
            this.selectCommodityStrategy.margin *
            this.selectCommodityStrategy.unitNumeral
          ).toFixed(2)
        localStorage.setItem('commFormDj', this.htTransactionVolume)
      }
    }
  },
  created: function() {
    // this.sell = buyLst[0].amount;
    // this.price = buyLst[0].amount;
    if (this.sessionInfoGetter.isLogin == 'true') {
      // this.currency();
      this.creditAvailable()
    }
    setTimeout(
      () => {
        hqProtocol.param_top.symbol = this.data // this.$store.state.hqData.marketDetails[0].symbolId
        if (this.data && this.data != '--') {
          hqWs.send(hqProtocol.param_top)
        } else {
          this.init()
        }
      },
      window.g.TOP_REFRESH_TIME ? window.g.TOP_REFRESH_TIME : 1000
    )
  },
  mounted: function() {
    console.log('-------------',this.tradeView);
    const _this = this
    setTimeout(() => {
      _this.initPrice()
    }, 1000)
    // 禁止input滚轮(兼容火狐)
    function MouseWheel(event) {
      event = event || window.event
      event.preventDefault()
    }
    const aInp = document.getElementsByTagName('input')
    for (let i = 0; i < aInp.length; i++) {
      aInp[i].addEventListener('DOMMouseScroll', MouseWheel, false)
    }
    // this.setLanguageCss()
    // if (this.sessionInfoGetter.isLogin == 'true') {
    //   this.getQueryparamet()
    // }
  },
  methods: {
    aggreementOk() {
      this.isCheckHt = true
    },
    // 展示协议 --- 带数据过去，最终协议要显示
    aggreementShow(type) {
      this.isBuy = type
      this.$refs.confirmDialog.showDialog()
    },
    // 进度条
    confirmAggreement() {
      this.$refs.hintDialog.showDialog()
    },
    // 协议文本弹框
    confirmHint() {
      this.$refs.aggreementDialog.showDialog(this.isBuy)
    },
    // 卖价格+ -
    pricebtnClick(ty) {
      this.emitChangeTypeLock()
      if (this.sell || this.sell == 0) {
        if (ty === 'down') {
          this.sell = (
            Number(this.sell) -
            Number(this.selectCommodityStrategy.minPriceChange)
          ).toFixed(this.item.coinDigitalNum)
        } else {
          this.sell = (
            Number(this.sell) +
            Number(this.selectCommodityStrategy.minPriceChange)
          ).toFixed(this.item.coinDigitalNum)
        }
      }
      if (Number(this.sell) < 0) {
        this.sell = 0
      }
    },
    // 卖数量 + -
    numsellClick(ty) {
      this.numSelllock = true
      if (this.number || this.number == 0) {
        if (ty === 'down') {
          this.number = (
            Number(this.number) -
            Number(this.selectCommodityStrategy.minAmountChange)
          ).toFixed(this.item.quantityNum)
        } else {
          this.number = (
            Number(this.number) +
            Number(this.selectCommodityStrategy.minAmountChange)
          ).toFixed(this.item.quantityNum)
        }
      }
      if (Number(this.number) < 0) {
        this.number = 0
      }
    },
    // 买价格 + -
    pricebtnbClick(ty) {
      this.emitChangeTypeLock()
      if (this.price || this.price == 0) {
        if (ty === 'down') {
          this.price = (
            Number(this.price) -
            Number(this.selectCommodityStrategy.minPriceChange)
          ).toFixed(this.item.coinDigitalNum)
        } else {
          this.price = (
            Number(this.price) +
            Number(this.selectCommodityStrategy.minPriceChange)
          ).toFixed(this.item.coinDigitalNum)
        }
      }
      if (Number(this.price) < 0) {
        this.price = 0
      }
    },
    // 买数量 + -
    numbuyClick(ty) {
      this.numBuylock = true
      if (this.num || this.num == 0) {
        if (ty === 'down') {
          this.num = (
            Number(this.num) -
            Number(this.selectCommodityStrategy.minAmountChange)
          ).toFixed(this.item.quantityNum)
        } else {
          this.num = (
            Number(this.num) +
            Number(this.selectCommodityStrategy.minAmountChange)
          ).toFixed(this.item.quantityNum)
        }
      }
      if (Number(this.num) < 0) {
        this.num = 0
      }
    },
    // 修改某一项变更市价/限价 变更selectTradeType为2,当为2时价格数量不在自动修改
    emitChangeTypeLock() {
      this.$emit('emitChangeTypeLock')
    },
    // 解锁top价格/数量随动的限制
    emitChangeTypeUnlock() {
      this.$emit('emitChangeTypeUnlock')
    },
    handleClose() {
      this.dialogVisible = false
      this.percentageNum = 0
      clearInterval(this.setIntervalTime)
    },
    handleClose1() {
      this.dialogVisible = false
      this.dialogDiscoverHt = false
    },
    format(percentage) {
      return percentage === 100 ? '100%' : `${percentage}%`
    },
    btnTimeFun() {
      const that = this
      this.disableHt = true
      this.timeText = window.g.BTN_Time
      this.timeInterval = setInterval(() => {
        if (Number(that.timeText) <= 0) {
          that.btnText = '我已阅读并同意'
          that.disableHt = false
          clearInterval(that.timeInterval)
          return
        }
        that.timeText--
        that.btnText = '我已阅读并同意' + '(' + that.timeText + 's' + ')'
      }, 1000)
    },
    // 确定按钮
    enterClick() {
      const that = this
      this.percentageNum = 0
      this.agreementFlag = true
      var a = (window.g.scheduleTime / 100) * 1000
      this.setIntervalTime = setInterval(() => {
        that.percentageNum++
        if (that.percentageNum == 100) {
          that.btnTimeFun()
          clearInterval(that.setIntervalTime)
          that.dialogVisible = false
          if (that.btnFlag == 1) {
            that.transBuyControl()
          } else {
            that.transSellControl()
          }
        }
      }, a)
    },
    // 取消按钮
    cancelClick() {
      this.dialogVisible = false
      if (this.btnFlag == 1) {
        this.transBuyControl()
      } else {
        this.transSellControl()
      }
      this.htSuccess()
    },
    init() {
      setTimeout(
        () => {
          hqProtocol.param_top.symbol = this.data // this.$store.state.hqData.marketDetails[0].symbolId
          if (this.data && this.data != '--') {
            hqWs.send(hqProtocol.param_top)
          } else {
            this.init()
          }
        },
        window.g.TOP_REFRESH_TIME ? window.g.TOP_REFRESH_TIME : 1000
      )
    },
    initPrice() {
      if (window.g.FAST_SET.FAST_AutoFill_price) {
        // 自动填充价格
        this.initPriceP()
      }
      if (window.g.FAST_SET.FAST_AutoFill_quantity) {
        // 自动填充数量
        this.initPriceM()
      }
    },
    // 拆分initPrice
    // 价格跟随top变动
    initPriceP() {
      let topn = 0
      topn = this.selectTop
      // top1价格
      if (
        this.buyLst.length > 0 &&
        this.buyLst[this.buyLst.length - 1 - topn][0] != '--'
      ) {
        this.sell = Number(
          this.buyLst[this.buyLst.length - 1 - topn][0]
        ).toFixed(this.item.coinDigitalNum)
      } else {
        this.sell = ''
      }
      if (this.sellLst.length > 0 && this.sellLst[topn][0] != '--') {
        this.price = Number(this.sellLst[topn][0]).toFixed(
          this.item.coinDigitalNum
        )
      } else {
        this.price = ''
      }
    },
    // 拆分initPrice
    // 数量跟随top变动 数量变化有单独的限制规则
    initPriceM() {
      let topn = 0
      topn = this.selectTop
      // top1数量 卖
      if (!this.numSelllock) {
        if (
          this.buyLst.length > 0 &&
          this.buyLst[this.buyLst.length - 1 - topn][2] != '--'
        ) {
          this.number = (
            Number(this.buyLst[this.buyLst.length - 1 - topn][2])
            // / this.selectCommodityStrategy.unitNumeral 2023 0804 去掉除以交易单
          ).toFixed(this.item.quantityNum)
        } else {
          this.number = ''
        }
      }
      // 买
      if (!this.numBuylock) {
        if (this.sellLst.length > 0 && this.sellLst[topn][2] != '--') {
          this.num = (
            Number(this.sellLst[topn][2])
            // / this.selectCommodityStrategy.unitNumeral 2023 0804 去掉除以交易单
          ).toFixed(this.item.quantityNum)
        } else {
          this.num = ''
        }
      }
    },
    changePasswordShow1() {
      if (this.passwordShow1 == 'password') {
        this.passwordShow1 = 'text'
      } else {
        this.passwordShow1 = 'password'
      }
    },
    changeType() {
      this.isBBToList = !this.isBBToList
    },
    changeRodio(e) {
      this.isChangedDisable = true
      this.radio = e
      let currentRo
      if (e == 2) {
        currentRo = 'USDT'
      } else if (e == 1) {
        currentRo = 'ETH'
      } else if (e == 0) {
        currentRo = 'BTC'
      }
      this.addr = ''
      this.currentChargeCoin = currentRo
      protocol.param_moneyio.param.type = 'in'
      protocol.param_moneyio.param.currency = currentRo
      protocol.param_moneyio.param.fromaddress = this.sessionInfoGetter.firmCode
      protocol.param_moneyio.param.toaddress = ''
      http.postFront(protocol.param_moneyio).then(response => {
        this.isChangedDisable = false
        const { code, message, address } = response.data
        if (code == 0) {
          this.addr = address

          this.selectGood = false
          this.addrCopy = address
          // }
          this.dialogChargeVisible = true
        } else {
          this.__TradeMessage(message)
        }
      })
    },
    limitBuyPrice() {
      this.emitChangeTypeLock()
      // const numStr = this.item.numStr
      if (this.$refs.prices.value.length >= 1) {
        // this.$refs.prices.value = this.$refs.prices.value.replace(
        //   numStr,
        //   '$1.$2'
        // )
        // this.price = this.$refs.prices.value
        this.price = this.inputMinChange(this.price, this.item.minPriceChange)
        // this.$refs.prices.value = this.inputMinChange(this.price, this.item.minPriceChange)
      } else {
        this.$refs.prices.value = this.$refs.prices.value.replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
        this.price = this.$refs.prices.value
      }
      // 同步协议展示字段
      this.htBsflag = 'B'
      this.htPrice = this.price
      this.htAmount = this.num
      this.htTransactionVolume = isNaN(this.price * this.num)
        ? '--'
        : (this.selectCommodityStrategy.marginType == '1'
          ? this.num *
          this.selectCommodityStrategy.margin *
          this.selectCommodityStrategy.unitNumeral
          : this.price *
          this.num *
          this.selectCommodityStrategy.margin *
          this.selectCommodityStrategy.unitNumeral
        ).toFixed(2)
      // this.getAnalogueMobile('B', that.data, that.price, that.num)
      localStorage.setItem('commFormPrice', this.price)
      localStorage.setItem('commFormNum', this.num)
      localStorage.setItem('commFormDj', this.htTransactionVolume)
    },
    inputMinChange(num, minChange) {
      // 空值检查
      if (num === '') return '';
      
      // 转换为数字
      const numValue = parseFloat(num);
      
      // 检查是否为有效数字
      if (isNaN(numValue)) {
        return '';
      }
      
      // 后台配置的小数位数
      const minDP = minChange.toString().split('.')[1]?.length ? minChange.toString().split('.')[1]?.length : 0;
      // 检查小数位数
      const decimalPart = num.toString().split('.')[1];
      if (decimalPart && decimalPart.length > minDP) {
        // 自动截断为2位小数
        return Math.floor(numValue * Math.pow(10, minDP)) / Math.pow(10, minDP)
      }
      return num
    },
    channelInputLimitPrice(e) {
      const key = e.key
      // 不允许输入'e'
      // if (key === 'e' || key === 'E' || key === '.') {
      if (this.item.minPriceChange.toString().split('.')[1]?.length) {
        if (key === 'e' || key === 'E') {
          e.returnValue = false
          return false
        }
      } else {
        if (key === 'e' || key === 'E' || key === '.') {
          e.returnValue = false
          return false
        }
      }
      return true
    },
    channelInputLimitNum(e) {
      const key = e.key
      // 不允许输入'e'
      // if (key === 'e' || key === 'E' || key === '.') {
      if (this.item.minAmountChange.toString().split('.')[1]?.length) {
        if (key === 'e' || key === 'E') {
          e.returnValue = false
          return false
        }
      } else {
        if (key === 'e' || key === 'E' || key === '.') {
          e.returnValue = false
          return false
        }
      }
      return true
    },
    limitBuyNumber() {
      // this.emitChangeTypeLock()
      this.numBuylock = true
      if (this.$refs.num.value && this.$refs.num.value.indexOf('-') > -1) {
        this.$refs.num.value = ''
        this.num = ''
      }
      // 2023.08.17 价格和数量只能输入整数,跟策略无关
      // const numStr = this.item.quantityStr
      // if (this.$refs.num.value.length >= 2) {
      //   this.$refs.num.value = this.$refs.num.value.replace(numStr, '$1.$2')
      //   this.num = this.$refs.num.value
      // } else {
      this.$refs.num.value = this.$refs.num.value.replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
      this.num = this.$refs.num.value
      // }
      // 同步协议展示字段
      this.htBsflag = 'B'
      this.htPrice = this.price
      this.htAmount = this.num
      this.htTransactionVolume = isNaN(this.price * this.num)
        ? '--'
        : (this.selectCommodityStrategy.marginType == '1'
          ? this.num *
          this.selectCommodityStrategy.margin *
          this.selectCommodityStrategy.unitNumeral
          : this.price *
          this.num *
          this.selectCommodityStrategy.margin *
          this.selectCommodityStrategy.unitNumeral
        ).toFixed(2)
      // this.getAnalogueMobile('B', that.data, that.price, that.num)
      localStorage.setItem('commFormPrice', this.price)
      localStorage.setItem('commFormNum', this.num)
      localStorage.setItem('commFormDj', this.htTransactionVolume)
    },
    limitBuyNumber1() {
      this.emitChangeTypeLock()
      // const numStr = this.item.quantityStr
      // if (this.$refs.marketnum.value.length >= 2) {
      //   this.$refs.marketnum.value = this.$refs.marketnum.value.replace(
      //     numStr,
      //     '$1.$2'
      //   )
      //   this.num = this.$refs.marketnum.value
      // } else {
      this.$refs.marketnum.value = this.$refs.marketnum.value.replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
      this.num = this.$refs.marketnum.value
      // }
    },
    limitSellNumber() {
      // this.emitChangeTypeLock()
      this.numSelllock = true
      if (this.$refs.sellnum.value && this.$refs.sellnum.value.indexOf('-') > -1) {
        this.$refs.sellnum.value = ''
        this.number = ''
      }
      // const numStr = this.item.quantityStr
      // if (this.$refs.sellnum.value.length >= 2) {
      //   this.$refs.sellnum.value = this.$refs.sellnum.value.replace(
      //     numStr,
      //     '$1.$2'
      //   )
      //   this.number = this.$refs.sellnum.value
      // } else {
      this.$refs.sellnum.value = this.$refs.sellnum.value.replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
      this.number = this.$refs.sellnum.value
      // }
      // 同步合同使用字段
      this.htBsflag = 'S'
      this.htPrice = this.sell
      this.htAmount = this.number
      this.htTransactionVolume = isNaN(this.sell * this.number)
        ? '--'
        : (this.selectCommodityStrategy.sellMarginType == '1'
          ? this.number *
            this.selectCommodityStrategy.sellMargin *
            this.selectCommodityStrategy.unitNumeral
          : this.sell *
            this.number *
            this.selectCommodityStrategy.sellMargin *
            this.selectCommodityStrategy.unitNumeral
        ).toFixed(2)
      // this.getAnalogueMobile('S', that.data, that.sell, that.num)
      localStorage.setItem('commFormPrice', this.sell)
      localStorage.setItem('commFormNum', this.number)
      localStorage.setItem('commFormDj', this.htTransactionVolume)
    },
    limitSellPrice() {
      this.emitChangeTypeLock()
      // const numStr = this.item.numStr
      if (this.$refs.sellprices.value.length >= 1) {
        // this.$refs.sellprices.value = this.$refs.sellprices.value.replace(
        //   numStr,
        //   '$1.$2'
        // )
        // this.sell = this.$refs.sellprices.value
        // this.$refs.sellprices.value = this.inputMinChange(this.sell, this.item.minPriceChange)
        this.sell = this.inputMinChange(this.sell, this.item.minPriceChange)
      } else {
        this.$refs.sellprices.value = this.$refs.sellprices.value.replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
        this.sell = this.$refs.sellprices.value
      }
      // 同步合同使用字段
      this.htBsflag = 'S'
      this.htPrice = this.sell
      this.htAmount = this.number
      this.htTransactionVolume = isNaN(this.sell * this.number)
        ? '--'
        : (this.selectCommodityStrategy.sellMarginType == '1'
          ? this.number *
            this.selectCommodityStrategy.sellMargin *
            this.selectCommodityStrategy.unitNumeral
          : this.sell *
            this.number *
            this.selectCommodityStrategy.sellMargin *
            this.selectCommodityStrategy.unitNumeral
        ).toFixed(2)
      // this.getAnalogueMobile('S', that.data, that.sell, that.num)
      localStorage.setItem('commFormPrice', this.sell)
      localStorage.setItem('commFormNum', this.number)
      localStorage.setItem('commFormDj', this.htTransactionVolume)
    },

    formatTooltip(val) {
      return val + '%'
    },
    // 卖数量改变
    sellAmountset(val) {
      this.emitChangeTypeLock()
      if (!this.sell) {
        this.number = ''
        return
      }
      let sellMargin = 0.01 // 默认不取0
      if (this.selectCommodityStrategy.sellMarginType == '1') {
        sellMargin = this.selectCommodityStrategy.sellMargin
      } else {
        sellMargin = Number(this.sell) * this.selectCommodityStrategy.sellMargin
      }
      let openFee = 0.01 // 默认不取0
      if (this.selectCommodityStrategy.openFeeType == '1') {
        openFee = this.selectCommodityStrategy.openFee
      } else {
        openFee = Number(this.sell) * this.selectCommodityStrategy.openFee
      }
      const current = val / 100
      const returnNum = global.util.floatMul(
        this.balance2 / (sellMargin + openFee),
        current
      )
      this.number = Math.floor(
        Number(Number(returnNum) / this.selectCommodityStrategy.unitNumeral)
      )
      if (this.number < 0) {
        this.number = 0
      }
    },
    buyAmountset(val) {
      this.emitChangeTypeLock()
      // this.balance1
      // this.price
      // 可买量
      if (!this.price) {
        this.num = ''
        return
      }
      let margin = 0.01 // 默认不取0
      if (this.selectCommodityStrategy.marginType == '1') {
        margin = this.selectCommodityStrategy.margin
      } else {
        margin = Number(this.price) * this.selectCommodityStrategy.margin
      }
      let openFee = 0.01 // 默认不取0
      if (this.selectCommodityStrategy.openFeeType == '1') {
        openFee = this.selectCommodityStrategy.openFee
      } else {
        openFee = Number(this.price) * this.selectCommodityStrategy.openFee
      }
      const current = val / 100
      const returnNum = global.util.floatMul(
        this.balance1 / (margin + openFee),
        current
      )
      this.num = Math.floor(
        Number(Number(returnNum) / this.selectCommodityStrategy.unitNumeral)
      )
      if (this.num < 0) {
        this.num = 0
      }
    },
    // 卖数量改变(市价)
    sellAmountset1(val) {
      this.emitChangeTypeLock()
      if (!this.sells) {
        this.number = ''
        return
      }
      let sellMargin = 0.01 // 默认不取0
      if (this.selectCommodityStrategy.sellMarginType == '1') {
        sellMargin = this.selectCommodityStrategy.margin
      } else {
        sellMargin = Number(this.sells) * this.selectCommodityStrategy.margin
      }
      let openFee = 0.01 // 默认不取0
      if (this.selectCommodityStrategy.openFeeType == '1') {
        openFee = this.selectCommodityStrategy.openFee
      } else {
        openFee = Number(this.sells) * this.selectCommodityStrategy.openFee
      }
      const current = val / 100
      const returnNum = global.util.floatMul(
        this.balance2 / (sellMargin + openFee),
        current
      )
      this.number = Math.floor(
        Number(Number(returnNum) / this.selectCommodityStrategy.unitNumeral)
      )
      if (this.number < 0) {
        this.number = 0
      }
    },
    buyAmountset1(val) {
      this.emitChangeTypeLock()
      // this.balance1
      // this.price
      // 可买量
      if (!this.prices) {
        this.num = ''
        return
      }
      let margin = 0.01 // 默认不取0
      if (this.selectCommodityStrategy.marginType == '1') {
        margin = this.selectCommodityStrategy.margin
      } else {
        margin = Number(this.prices) * this.selectCommodityStrategy.margin
      }
      let openFee = 0.01 // 默认不取0
      if (this.selectCommodityStrategy.openFeeType == '1') {
        openFee = this.selectCommodityStrategy.openFee
      } else {
        openFee = Number(this.prices) * this.selectCommodityStrategy.openFee
      }
      const current = val / 100
      const returnNum = global.util.floatMul(
        this.balance1 / (margin + openFee),
        current
      )
      this.num = Math.floor(
        Number(Number(returnNum) / this.selectCommodityStrategy.unitNumeral)
      )
      if (this.num < 0) {
        this.num = 0
      }
    },
    transSellbefore() {
      if (this.ordersDialog) {
        this.setOrdersDialog()
        return
      }
      this.transSell()
    },
    transSell: function() {
      this.btnFlag = 2
      // if (this.isChangeMarginPsdGetter) {
      //   return this.__TradeMessage('请先修改资金密码')
      // }
      if (this.h_avilibleMargin < 0) {
        return this.__TradeMessage('您当前的风险率过高，请进行转让或追加履约订金。')
      }
      // 配置是否有弹窗提示
      const showDialog = window.g.FAST_SET.FAST_show_Dialog
      if (showDialog) {
      // 陇南普通版 默认弹窗 2023 06 27
        this.$confirm('确认下单, 是否继续?', {
          customClass: 'blackMessage',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          // type: 'warning',
          closeOnClickModal: false,
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              const that = this
              instance.$refs['confirm'].$el.onclick = (function(e) {
                e = e || window.event
                if (e.detail === 0) {
                  that.ordersDialog = true
                }
              }())
            }
            done()
          }
        }).then(() => {
          this.transSellControl()
        }).catch(() => {
        })
      } else {
        this.transSellControl()
      }
    },
    transSellControl() {
      this.yesNo2 = true
      let status = false
      let msg
      if (this.number == '') {
        this.shortcuts_F4()
        status = true
        msg = '请输入卖出数量'
        // this.__TradeMessage('请输入卖出数量')
        this.yesNo2 = false
      } else {
        if (
          this.canSell == '--' ||
          Number(this.canSell) == 0 ||
          Number(this.number) > Number(this.canSell)
        ) {
          this.shortcuts_F4()
          status = true
          msg = '超出可下单最大数量'
          // this.__TradeMessage('超出可下单最大数量!')
          this.yesNo2 = false
        } else if (this.sell < 0) {
          this.shortcuts_F3()
          status = true
          msg = '请输入不小于0的卖出价！'
          // this.__TradeMessage('请输入不小于0的卖出价！')
          this.yesNo2 = false
        } else if (this.sell == '') {
          this.shortcuts_F3()
          status = true
          msg = '请输入卖出价'
          // this.__TradeMessage('请输入卖出价')
          this.yesNo2 = false
        } else if (this.number < 0) {
          this.shortcuts_F3()
          status = true
          msg = '卖出量不可小于0！'
          // this.__TradeMessage('卖出量不可小于0！')
          this.yesNo2 = false
        } else if (isNaN(this.sell)) {
          this.shortcuts_F1()
          status = true
          msg = '请输入价格'
          // this.__TradeMessage('请输入价格!')
          this.yesNo = false
        } else if (!this.isCheckHt) {
          // this.dialogVisible = true
          // 协议上需要填写相关信息
          const that = this
          this.htBsflag = 'S'
          this.htPrice = this.sell
          this.htAmount = this.number
          this.htTransactionVolume = isNaN(this.sell * this.number)
            ? '--'
            : (this.selectCommodityStrategy.sellMarginType == '1'
              ? this.number *
                this.selectCommodityStrategy.sellMargin *
                this.selectCommodityStrategy.unitNumeral
              : this.sell *
                this.number *
                this.selectCommodityStrategy.sellMargin *
                this.selectCommodityStrategy.unitNumeral
            ).toFixed(2)
          // this.getAnalogueMobile('S', that.data, that.sell, that.num)
          localStorage.setItem('commFormPrice', this.sell)
          localStorage.setItem('commFormNum', this.number)
          localStorage.setItem('commFormDj', this.htTransactionVolume)
          this.aggreementShow(2) // --- 新 协议
          this.agreementFlag = false
          // this.__TradeMessage('请先同意签署《订单商品销售协议》')
          this.yesNo2 = false
        } else {
          const that = this
          this.htBsflag = 'S'
          this.htPrice = this.sell
          this.htAmount = this.number
          this.htTransactionVolume = isNaN(this.sell * this.number)
            ? '--'
            : (
              this.sell *
                this.number *
                this.selectCommodityStrategy.unitNumeral
            ).toFixed(2)
          // this.getAnalogueMobile('S', that.data, that.sell, that.number)
          // this.Ht(function() {
          protocol.param_trades.param.price = that.sell
          protocol.param_trades.param.quantity = that.number
          protocol.param_trades.param.bsFlag = 'S'
          protocol.param_trades.param.commodityId = that.data
          http.postFront(protocol.param_trades).then(response => {
            that.yesNo2 = false
            if (response.status == -404) {
              // 挂摘牌失败使用对话框提示
              if (window.g.FAST_SET.FAST_fail_Dialog) {
                that.__TradeMessage({
                  message: '下单失败',
                  duration: 1000
                })
              }
              if (window.g.FAST_SET.FAST_fail_clear) {
                that.sell = ''
                that.number = ''
              }
              return
            }
            if (response.data && response.data.code == '0') {
              // 挂摘牌成功使用对话框提示
              if (window.g.FAST_SET.FAST_success_Dialog) {
                that.__TradeMessage({ message: response.data.message, duration: 1000 })
              }
              that.creditAvailable()
              that.shortcuts_F4()
              that.createPlayer()
              // 成功下单后 解除top随动价格显示限制
              that.emitChangeTypeUnlock()
              // 挂摘牌成功自动清除挂摘牌信息
              if (window.g.FAST_SET.FAST_success_clear) {
                that.sell = ''
                that.number = ''
              }
              // that.sell = ''
              // if (Number(that.buyLst[that.buyLst.length - 1][0]) > 0) {
              //   that.sell = Number(
              //     that.buyLst[that.buyLst.length - 1][0]
              //   ).toFixed(that.coinSmallDigital.coinDigitalNum)
              //   that.shortcuts_F4()
              // } else {
              //   that.sell = ''
              //   that.shortcuts_F3()
              // }
              // that.number = ''
            } else if (response.data.code == '-10035') {
              // 挂摘牌失败使用对话框提示
              if (window.g.FAST_SET.FAST_fail_Dialog) {
                that.__TradeMessage({
                  message: '请您先进行实名认证再进行交易',
                  duration: 1000
                })
              }
              that.$router.push('/usercenter/highCertification')
            } else {
              // 挂摘牌失败使用对话框提示
              if (window.g.FAST_SET.FAST_fail_Dialog) {
                that.__TradeMessage({ message: response.data.message, duration: 1000 })
              }
              if (window.g.FAST_SET.FAST_fail_clear) {
                that.sell = ''
                that.number = ''
              }
            }
          })
          // })
          // this.dialogVisible = true
          // this.agreementFlag = false
        }
      }
      if (status) {
        if (window.g.FAST_SET.FAST_fail_Dialog) {
          this.__TradeMessage(msg)
        }
        if (window.g.FAST_SET.FAST_fail_clear) {
          this.sell = ''
          this.number = ''
        }
      }
      setTimeout(() => {
        this.numSelllock = false
        this.initPrice()
      }, 0)
    },
    // 提示音播放
    createPlayer() {
      if (window.g.FAST_SET.FAST_Ordersuccess_Playsound) {
        const audio = new Audio(require('../../../assets/voice/1.mp3'))
        audio.play()
      }
    },
    setOrdersDialog() {
      setTimeout(() => {
        this.ordersDialog = false
      }, 100)
    },
    transBuybefore() {
      if (this.ordersDialog) {
        this.setOrdersDialog()
        return
      }
      this.transBuy()
    },
    // 买入开多
    transBuy: function() {
      this.btnFlag = 1
      // if (this.isChangeMarginPsdGetter) {
      //   return this.__TradeMessage('请先修改资金密码')
      // }
      if (this.h_avilibleMargin < 0) {
        return this.__TradeMessage('您当前的风险率过高，请进行转让或追加履约订金。')
      }
      // 配置是否有弹窗提示
      const showDialog = window.g.FAST_SET.FAST_show_Dialog
      if (showDialog) {
        // 陇南普通版 默认弹窗 2023 06 27
        this.$confirm('确认下单, 是否继续?', {
          customClass: 'blackMessage',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          // type: 'warning',
          closeOnClickModal: false,
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              const that = this
              instance.$refs['confirm'].$el.onclick = (function(e) {
                e = e || window.event
                if (e.detail === 0) {
                  that.ordersDialog = true
                }
              }())
            }
            done()
          }
        }).then(() => {
          this.transBuyControl()
        }).catch(() => {
        })
      } else {
        this.transBuyControl()
      }
    },
    // 查看对手方手机号
    getAnalogueMobile(bsFlag, commodityId, price, quantity) {
      protocol.param_getAnalogueMobile.param.bsFlag = bsFlag
      protocol.param_getAnalogueMobile.param.commodityId = commodityId
      protocol.param_getAnalogueMobile.param.price = price
      protocol.param_getAnalogueMobile.param.quantity = quantity
      http.postFront(protocol.param_getAnalogueMobile).then(response => {
        var { value, code } = response.data
        if (Number(code) === 0) {
          localStorage.setItem('dfName', value[0])
          this.$store.commit('setAnalogueMobileMes', value)
        }
      })
    },
    transBuyControl() {
      this.yesNo = true
      let status = false
      let msg = 1
      if (this.num == '') {
        this.shortcuts_F2()
        status = true
        msg = '请输入买入数量'
        // this.__TradeMessage('请输入买入数量')
        this.yesNo = false
      } else {
        if (
          this.canBuy == '--' ||
          Number(this.canBuy) == 0 ||
          Number(this.num) > Number(this.canBuy)
        ) {
          status = true
          msg = '超出可下单最大数量!'
          this.shortcuts_F2()
          // this.__TradeMessage('超出可下单最大数量!')
          this.yesNo = false
        } else if (this.price < 0) {
          this.shortcuts_F1()
          status = true
          msg = '请输入不小于0的买入价!'
          // this.__TradeMessage('请输入不小于0的买入价!')
          this.yesNo = false
        } else if (this.price == '') {
          this.shortcuts_F1()
          status = true
          msg = '请输入买入价!'
          // this.__TradeMessage('请输入买入价')
          this.yesNo = false
        } else if (this.num < 0) {
          this.shortcuts_F1()
          status = true
          msg = '买入量不可小于0!'
          // this.__TradeMessage('买入量不可小于0!')
          this.yesNo = false
        } else if (isNaN(this.price)) {
          this.shortcuts_F1()
          status = true
          msg = '请输入价格!'
          this.__TradeMessage('请输入价格!')
          this.yesNo = false
        } else if (!this.isCheckHt) {
          // this.dialogVisible = true

          // 协议上需要填写相关信息
          const that = this
          this.htBsflag = 'B'
          this.htPrice = this.price
          this.htAmount = this.num
          this.htTransactionVolume = isNaN(this.price * this.num)
            ? '--'
            : (this.selectCommodityStrategy.marginType == '1'
              ? this.num *
              this.selectCommodityStrategy.margin *
              this.selectCommodityStrategy.unitNumeral
              : this.price *
              this.num *
              this.selectCommodityStrategy.margin *
              this.selectCommodityStrategy.unitNumeral
            ).toFixed(2)
          // this.getAnalogueMobile('B', that.data, that.price, that.num)
          localStorage.setItem('commFormPrice', this.price)
          localStorage.setItem('commFormNum', this.num)
          localStorage.setItem('commFormDj', this.htTransactionVolume)
          this.aggreementShow(1) // --- 新 协议
          this.agreementFlag = false
          // this.__TradeMessage('请先同意签署《订单商品销售协议》')
          this.yesNo = false
        } else {
          const that = this
          this.htBsflag = 'B'
          this.htPrice = this.price
          this.htAmount = this.num
          this.htTransactionVolume = isNaN(this.price * this.num)
            ? '--'
            : (
              this.price *
                this.num *
                this.selectCommodityStrategy.unitNumeral
            ).toFixed(2)
          // this.getAnalogueMobile('B', that.data, that.price, that.num)
          // this.Ht(function() {
          protocol.param_trades.param.price = that.price
          // } else {that.num
          //   protocol.param_trades.param.price = this.prices;
          // }
          protocol.param_trades.param.quantity = that.num
          protocol.param_trades.param.bsFlag = 'B'
          protocol.param_trades.param.commodityId = that.data
          http.postFront(protocol.param_trades).then(response => {
            that.yesNo = false
            if (response.status == -404) {
              // 挂摘牌失败使用对话框提示
              if (window.g.FAST_SET.FAST_fail_Dialog) {
                that.__TradeMessage({
                  message: '下单失败',
                  duration: 1000
                })
              }
              if (window.g.FAST_SET.FAST_fail_clear) {
                that.price = ''
                that.num = ''
              }
            } else if (response.data && response.data.code == '0') {
              // 挂摘牌成功使用对话框提示
              if (window.g.FAST_SET.FAST_success_Dialog) {
                that.__TradeMessage({ message: response.data.message, duration: 1000 })
              }
              that.creditAvailable()
              that.shortcuts_F2()
              that.createPlayer()
              // 成功下单后 解除top随动价格显示限制
              that.emitChangeTypeUnlock()
              // 挂摘牌成功自动清除挂摘牌信息
              if (window.g.FAST_SET.FAST_success_clear) {
                that.price = ''
                that.num = ''
              }
              // this.price = ''
              // if (Number(that.sellLst[0][0]) > 0) {
              //   that.price = Number(that.sellLst[0][0]).toFixed(
              //     that.coinSmallDigital.coinDigitalNum
              //   )
              //   that.shortcuts_F2()
              // } else {
              //   that.price = ''
              //   that.shortcuts_F1()
              // }
              // that.num = ''
            } else if (response.data.code == '-10035') {
              // 挂摘牌失败使用对话框提示
              if (window.g.FAST_SET.FAST_fail_Dialog) {
                that.__TradeMessage({
                  message: '请您先进行实名认证再进行交易',
                  duration: 1000
                })
              }
              that.$router.push('/usercenter/highCertification')
            } else {
              // 挂摘牌失败使用对话框提示
              if (window.g.FAST_SET.FAST_fail_Dialog) {
                that.__TradeMessage({ message: response.data.message, duration: 1000 })
              }
              if (window.g.FAST_SET.FAST_fail_clear) {
                that.price = ''
                that.num = ''
              }
            }
          })
          // })
          // this.dialogVisible = true
          // this.agreementFlag = false
        }
      }
      if (status) {
        if (window.g.FAST_SET.FAST_fail_Dialog) {
          this.__TradeMessage(msg)
        }
        if (window.g.FAST_SET.FAST_fail_clear) {
          this.price = ''
          this.num = ''
        }
      }
      setTimeout(() => {
        this.numBuylock = false
        this.initPrice()
      }, 0)
    },
    // 合同
    /**
     * 合同
     * bsflag 买卖方向 B S
     * type 交易类型 X:限价; S:市价
     */
    Ht(js) {
      // 点击确认
      if (this.agreementFlag) {
        this.dialogDiscoverHt = true
      }
      this.Htjs = js
    },
    // 合同通过
    htSuccess() {
      this.dialogDiscoverHt = false
      this.dialogVisible = false
      if (this.Htjs) {
        this.Htjs()
      }
    },
    // 市价
    marketSell: function() {
      // if (this.isChangeMarginPsdGetter) {
      //   return this.__TradeMessage('请先修改资金密码')
      // }
      const obj = JSON.parse(
        localStorage.getItem(`settingDea${this.sessionInfoGetter.tel}`)
      )
      if (obj === true || obj === 'true') {
        const _this = this
        this.$alert('确认下单?', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            _this.marketSellControl()
          }
        })
      } else {
        this.marketSellControl()
      }
    },
    marketSellControl() {
      this.yesNo4 = true
      if (this.number == '') {
        this.shortcuts_F4()
        this.__TradeMessage('请输入卖出数量')
        this.yesNo4 = false
      } else {
        if (this.number < 0) {
          this.shortcuts_F3()
          this.__TradeMessage('卖出量不可小于0！')
          this.yesNo4 = false
        } else if (!this.isCheckHt) {
          this.__TradeMessage('请先同意签署《订单商品销售协议》')
          this.yesNo4 = false
        } else {
          const that = this
          this.htBsflag = 'S'
          this.htPrice = this.sells
          this.htAmount = this.number
          this.htTransactionVolume = isNaN(this.sells * this.number)
            ? '--'
            : (
              this.sells *
                this.number *
                this.electCommodityStrategy.unitNumeral
            ).toFixed(2)
          // this.Ht(function() {
          protocol.param_marketTake.param.quantity = that.number
          protocol.param_marketTake.param.bsFlag = 'S'
          protocol.param_marketTake.param.commodityId = that.data
          http.postFront(protocol.param_marketTake).then(response => {
            that.yesNo4 = false
            if (response.status == -404) {
              return that.__TradeMessage({
                message: '下单失败',
                duration: 1000
              })
            }
            if (response.data && response.data.code == '0') {
              that.__TradeMessage({ message: response.data.message, duration: 1000 })
              that.creditAvailable()
              // that.sell = ''
              // if (Number(that.buyLst[that.buyLst.length - 1][0]) > 0) {
              //   that.sell = Number(
              //     that.buyLst[that.buyLst.length - 1][0]
              //   ).toFixed(that.coinSmallDigital.coinDigitalNum)
              //   that.shortcuts_F4()
              // } else {
              //   that.sell = ''
              //   that.shortcuts_F3()
              // }
              // that.number = ''
            } else if (response.data.code == '-10035') {
              that.__TradeMessage({
                message: '请您先进行实名认证再进行交易',
                duration: 1000
              })
              that.$router.push('/usercenter/highCertification')
            } else {
              that.__TradeMessage({ message: response.data.message, duration: 1000 })
            }
          })
          // })
        }
      }
    },
    marketBuy: function() {
      // if (this.isChangeMarginPsdGetter) {
      //   return this.__TradeMessage('请先修改资金密码')
      // }
      const obj = JSON.parse(
        localStorage.getItem(`settingDea${this.sessionInfoGetter.tel}`)
      )
      if (obj === true || obj === 'true') {
        const _this = this
        this.$alert('确认下单?', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            _this.marketBuyControl()
          }
        })
      } else {
        this.marketBuyControl()
      }
    },
    marketBuyControl() {
      this.yesNo3 = true
      if (this.num == '') {
        this.shortcuts_F2()
        this.__TradeMessage('请输入买入数量')
        this.yesNo3 = false
      } else if (!this.isCheckHt) {
        this.__TradeMessage('请先同意签署《订单商品销售协议》')
        this.yesNo3 = false
      } else {
        if (this.num < 0) {
          this.shortcuts_F1()
          this.__TradeMessage('买入量不可小于0!')
          this.yesNo3 = false
        } else {
          const that = this
          this.htBsflag = 'B'
          this.htPrice = this.prices
          this.htAmount = this.num
          this.htTransactionVolume = isNaN(this.prices * this.num)
            ? '--'
            : (
              this.prices *
                this.num *
                this.selectCommodityStrategy.unitNumeral
            ).toFixed(2)
          // this.Ht(function() {
          protocol.param_marketTake.param.quantity = that.num
          protocol.param_marketTake.param.bsFlag = 'B'
          protocol.param_marketTake.param.commodityId = that.data
          http.postFront(protocol.param_marketTake).then(response => {
            that.yesNo3 = false
            if (response.status == -404) {
              return that.__TradeMessage({
                message: '下单失败',
                duration: 1000
              })
            }
            if (response.data && response.data.code == '0') {
              that.__TradeMessage({ message: response.data.message, duration: 1000 })
              that.creditAvailable()
              // that.price = ''
              // if (Number(that.sellLst[0][0]) > 0) {
              //   that.price = Number(that.sellLst[0][0]).toFixed(
              //     that.coinSmallDigital.coinDigitalNum
              //   )
              //   that.shortcuts_F2()
              // } else {
              //   that.price = ''
              //   that.shortcuts_F1()
              // }
              // that.num = ''
            } else if (response.data.code == '-10035') {
              that.__TradeMessage({
                message: '请您先进行实名认证再进行交易',
                duration: 1000
              })
              that.$router.push('/usercenter/highCertification')
            } else {
              that.__TradeMessage({ message: response.data.message, duration: 1000 })
            }
          })
          // })
        }
      }
    },
    // 可用资金 // 这个方法没什么用
    creditAvailable() {
      if (this.h_avilibleMargin) {
        this.balance1 = this.h_avilibleMargin
        this.balance2 = this.h_avilibleMargin
      }
    },
    // 手动刷新可用
    refreshAccount() {
      if (this.h_avilibleMargin) {
        this.balance1 = this.h_avilibleMargin
        this.balance2 = this.h_avilibleMargin
      }
    },
    // 根据语言改变样式
    setLanguageCss() {
      // 防止清缓存后数据消失
      this.$i18n.locale =
        localStorage.lang || navigator.language.slice(-2).toLowerCase()
      switch (localStorage.lang) {
        case 'en':
          localStorage.setItem('isEnRealTimeTransCC', true)
          this.isEnRealTimeTransCC = localStorage.isEnRealTimeTransCC
          break
        default:
          break
      }
    },
    // 快捷键触发事件 切换选中
    shortcuts_F1(event) {
      this.$refs.prices.focus()
    },
    shortcuts_F2(event) {
      if (this.tradeType == 'x') {
        this.$refs.num.select()
      } else {
        this.$refs.marketnum.focus()
      }
    },
    shortcuts_F3(event) {
      this.$refs.sellprices.focus()
    },
    shortcuts_F4(event) {
      if (this.tradeType == 'x') {
        this.$refs.sellnum.select()
      } else {
        this.$refs.marketsellnum.focus()
      }
    },
    // 水平
    shortcuts_horizontal(event) {
      if (this.$refs.prices === document.activeElement) {
        this.shortcuts_F3()
      } else if (this.$refs.sellprices === document.activeElement) {
        this.shortcuts_F1()
      } else if (this.$refs.num === document.activeElement) {
        this.shortcuts_F4()
      } else if (this.$refs.sellnum === document.activeElement) {
        this.shortcuts_F2()
      } else if (this.$refs.marketnum === document.activeElement) {
        this.shortcuts_F4()
      } else if (this.$refs.marketsellnum === document.activeElement) {
        this.shortcuts_F2()
      }
    },
    // 垂直
    shortcuts_verticality(event) {
      if (this.$refs.prices === document.activeElement) {
        this.shortcuts_F2()
      } else if (this.$refs.sellprices === document.activeElement) {
        this.shortcuts_F4()
      } else if (this.$refs.num === document.activeElement) {
        this.shortcuts_F1()
      } else if (this.$refs.sellnum === document.activeElement) {
        this.shortcuts_F3()
      } else {
        if (this.buyOrSell == 'buy') {
          this.shortcuts_F1()
        } else {
          this.shortcuts_F3()
        }
      }
    },
    // 微调数量/价格
    shortcuts_verticality_up(event) {
      if (this.$refs.prices === document.activeElement) {
        if (this.price) {
          this.price = Number(this.price) + 1
        } else {
          this.price = 1
        }
      } else if (this.$refs.sellprices === document.activeElement) {
        if (this.sell) {
          this.sell = Number(this.sell) + 1
        } else {
          this.sell = 1
        }
      } else if (this.$refs.num === document.activeElement) {
        if (this.num) {
          this.num = Number(this.num) + 1
        } else {
          this.num = 1
        }
      } else if (this.$refs.sellnum === document.activeElement) {
        if (this.number) {
          this.number = Number(this.number) + 1
        } else {
          this.number = 1
        }
      } else {
        if (this.buyOrSell == 'buy') {
          this.shortcuts_F1()
        } else {
          this.shortcuts_F3()
        }
      }
    },
    // 微调数量/价格
    shortcuts_verticality_down(event) {
      if (this.$refs.prices === document.activeElement) {
        if (this.price && this.price > 1) {
          this.price = Number(this.price) - 1
        } else {
          this.price = 1
        }
      } else if (this.$refs.sellprices === document.activeElement) {
        if (this.sell && this.sell > 1) {
          this.sell = Number(this.sell) - 1
        } else {
          this.sell = 1
        }
      } else if (this.$refs.num === document.activeElement) {
        if (this.num && this.num > 1) {
          this.num = Number(this.num) - 1
        } else {
          this.num = 1
        }
      } else if (this.$refs.sellnum === document.activeElement) {
        if (this.number && this.number > 1) {
          this.number = Number(this.number) - 1
        } else {
          this.number = 1
        }
      } else {
        if (this.buyOrSell == 'buy') {
          this.shortcuts_F1()
        } else {
          this.shortcuts_F3()
        }
      }
    },
    // 订立
    shortcuts_dl() {
      this.$store.commit('dlclick')
    },
    // 转让
    shortcuts_zr() {
      this.$store.commit('zrclick')
    },
    // 切换买
    shortcuts_buy() {
      this.$store.commit('buyclick')
    },
    // 切换卖
    shortcuts_sell() {
      this.$store.commit('sellclick')
    },
    lowPriceEnter() {
      this.$refs.dialog_highPrice.focus()
    },
    // 范围撤单
    tackAndLossConfirm() {
      let isOK = true
      if (this.transfer.lowPrice == '') {
        isOK = false
        this.__TradeMessage('请输入撤单范围最低价')
      } else if (this.transfer.highPrice == '') {
        isOK = false
        this.__TradeMessage('请输入撤单范围最高价')
      } else if (Number(this.transfer.lowPrice) < 0) {
        isOK = false
        this.__TradeMessage('最低价需大于0!')
      } else if (Number(this.transfer.highPrice) < 0) {
        isOK = false
        this.__TradeMessage('最高价需大于0!')
      } else if (
        Number(this.transfer.lowPrice) > Number(this.transfer.highPrice)
      ) {
        isOK = false
        this.__TradeMessage('最低价不能大于最高价')
      }

      if (isOK) {
        this.param_rangeCancel()
      }
    },
    param_rangeCancel() {
      this.disablePC = true
      protocol.param_rangeCancel.param.highPrice = this.transfer.highPrice
      protocol.param_rangeCancel.param.lowPrice = this.transfer.lowPrice
      protocol.param_rangeCancel.param.commodityId = this.data
      http.postFront(protocol.param_rangeCancel).then(response => {
        const { code, message } = response.data
        this.dialogDiscover = false
        this.disablePC = false
        this.transfer = {
          highPrice: '',
          lowPrice: ''
        }
        this.__TradeMessage(message)
        if (code == 0) {
          // do somthing
        }
      })
    },
    // 改变限价/市价
    changeTradeType() {
      if (this.tradeType == 'x') {
        this.tradeType = 's'
      } else {
        this.tradeType = 'x'
      }
    },
    reStart() {
      hqWs.reStart()
    },
    // 替换全局message
    __TradeMessage(m) {
      this.$message.closeAll()
      this.$nextTick(() => {
        this.$message(m)
      })
    }
  }
}
</script>
<style scoped lang="scss">
// /deep/ .el-slider__stop{
//   width: 12px !important;
//   height: 12px !important;
//    background: #ffff;
//    border-radius: 2px;
//   border: 1px solid #989898;
//   box-sizing: border-box;
// }
/deep/ .el-slider__marks-stop{
  display: none;
}
/deep/.buyStep .el-slider__button {
  box-sizing: border-box;
  width: 10px;
  height: 10px;
  // background-color: #d04c64;
  border: 1px solid #ffffff;
  border: none;
}
/deep/.tradStep  .el-slider__button {
  box-sizing: border-box;
  width: 10px;
  height: 10px;
  background-color: #ffffff;
  border: none;
}
/deep/ .el-slider__runway{
  height: 2px;
  margin: 4px 0;
}
/deep/ .el-slider__bar{
  height: 3px;
}
/deep/ .el-radio__inner{
  width: 10px;
  height: 10px;
  background-color: #989898;
  border: none;
  border-radius: 2px;
}
// /deep/ .el-slider__marks-text{
//   width: 33px;
// }
/deep/ #btns.is-disabled {
  color: #fff !important;
  background-color: #409eff !important;
  border-color: #409eff !important;
}
/deep/ #gsHt .el-dialog {
  overflow-y: auto;
}
/deep/ .el-radio__inner{
  border-radius: 0%;
  &::after{
    border-radius: 0;
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}
.transcc_new_NewFooter_left_top{
  display: flex;
  align-items: center;
  .transcc_new_NewFooter_left--left{
    // width: 202px;
    flex: 1;
    flex-shrink: 0;
    .el-col-21{
      margin-bottom: 10px !important;
    }
  }
}
.transcc_new_NewFooter_left_bottom{
  margin-top: 10px;
}
.currentCoin {
  background-color: transparent;
  height: 110px;
  .currentRodio {
    height: 50px;
    line-height: 50px;
    padding-left: 10px;
  }
  .currentDian {
    display: inline-block;
    width: 25%;
    line-height: 50px;
    text-indent: 10px;
    /* border-bottom:1px solid #131625; */
  }
  .currentAddress {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    width: 82%;
    margin: 5px 0 5px 10px;
    border: 1px solid #1b1d24;
    text-indent: 10px;
    color: #bfc3ce;
  }
  .currentCopy {
    line-height: 40px;
    display: inline-block;
    width: 14%;
    padding-left: 18px;
    box-sizing: border-box;
    color: #bfc3ce;
  }
}
.tip .tips p {
  line-height: 30px;
}
.box {
  width: 100%;
  height: 100%;
  padding-top: 10px;
  /* border-top: 35px solid #111217; */
  .maintrans {
    width: 100%;
    /* padding-left: 25px; */
    margin: 0 auto;
    box-sizing: border-box;
    .title {
      height: 35px;
      margin-bottom: 10px;
      color: #f0f1f4;
      :last-child {
        float: right;
        margin-right: -150px;
      }
      li {
        float: left;
        line-height: 35px;
        font-size: 14px;
        width: 70px;
        margin-right: 39px;
        /* text-align: center; */
      }
    }
    .content {
      width: 100%;
      height: 100%; // 与金额对齐
      padding-top: 0;
      border-top: none !important;
      .priceText {
        /* display: inline-block; */
        // width: 72px;
        display: inline-block;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #EEEEEE;
      } //最大数值的限制,样式
      .priceNum {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #EEEEEE;
        /* display: inline-block; */
        /* width: 105px; */
        // overflow: hidden;
      }
      li {
        /* float:left;
        width: 50%;
        box-sizing:border-box; */
      } // 买入
      .buyStep,
      .tradStep {
        margin-top: 10px;
        margin-bottom: 34px;
        padding: 0 9px;
      }
      .left {
        // float: left;
        display: flex;
        flex-direction: column;
        // width: 48%;
        box-sizing: border-box;
        height: 460px;
        // padding: 0 15px 0 40px;
        .hx {
          /* height: 19px;
          margin-bottom: 11px;
          font-size:16px; */
          .login,
          .register {
            font-size: 14px;
            color: white;
          }
          .word,
          .start {
            font-size: 12px;
            color: #556d89;
          }
        }
        .top {
          position: relative;
          font-size: 14px;
          width: 97%;
          height: 15px;
          margin-bottom: 20px;
          color: rgba(255, 255, 255, 0.4);
          .message {
            width: 65%;
            float: left;
            margin-bottom: 8px;
          }
          .chong {
            position: absolute;
            /* top: 20px; */
            right: 0px;
            width: 35px;
            text-align: right;
            color: #99ccff;
            cursor: pointer;
            font-weight: 900;
          }
          .huazhuan {
            position: absolute;
            /* top: 20px; */
            right: 75px;
            width: 35px;
            text-align: right;
            color: #99ccff;
            cursor: pointer;
            font-weight: 900;
          }
          .chargeMoney {
            right: 0;
          }
          .fee {
            right: -20px;
            a {
              color: #99ccff;
            }
          }
        } // 买入里第二个ul
        /* .price {
          height: 20px;
          margin-bottom: 12px;
          .message {
            width: 65%;
            float: left;
          }
          .chong {
            width: 20%;
            text-align: right;
          }
        } */
        .price {
          .message {
            width: 100%;
            position: relative;
            margin-bottom: 10px;
          }
          .chong {
            /* width: 20%; */
            text-align: right;
          }
        }
        .sty {
          box-sizing: border-box;
          height: 30px;
          border: 1px solid #989898;
          border-radius: 5px;
          background-color: rgba(19, 22, 37, 0.2);
          width: 174px;
          outline-style: none;
          color: #EEEEEE;
          &:focus,&:hover{
            border-color: #989898;
          }
        }
        .unit {
          position: absolute;
          display: inline-block;
          top: 216px;
          left: 45px;
        }
        .sum {
          font-size: 14px;
          width: 100%;
          // margin: 18px 0 10px 0;
          display: flex;
          justify-content: space-between;
          color: rgba(255, 255, 255, 0.4) !important;
          .message {
            // margin: 0 5px;
            display: flex;
            width: 100%;
            // margin: 0;
            justify-content: flex-start;
          }
          .chong {
            //以前是40%
            /* width: 20%; */
            display: none;
            text-align: right;
          }
        }
        .btn {
          background-color: transparent;
          border: 2px solid #989898;
          height: 28px;
          line-height: 24px;
          border-radius: 17px;
          width: 100%;
          outline-style: none;
          display: block;
          margin: 10px auto;
          font-weight: bold;
          color: #EEEEEE;
        }
        .btnA {
          background-color: #4e5985;
          height: 32px;
          border-radius: 5px;
          width: 64%;
          outline-style: none;
          margin-bottom: 10px;
          border: 0;
          display: block;
          margin: 10px auto;
          a {
            color: #fff;
          }
          span {
            color: #fff;
          }
          .login:hover,
          .register:hover {
            // color:#7D7E7F;
            color: #fff;
          }
        }
      }
    }
  }
}
.now {
  width: 20%;
  text-align: left;
  color: #f0f1f4;
}
.rate,
.rate .rate-link {
  margin: 0 !important;
  color: #99ccff;
  cursor: pointer;
}
input[type='number'] {
  text-indent: 8px;
}
/* 添加了响应式布局方式 */
@media screen and (min-width: 1600px) {
  .box .maintrans {
    // 限价交易容器
    width: 100%;
    /* margin: -40px auto 0 auto; */
    padding-left: 0 !important;
  }
  .box .maintrans .content > li {
    // 限价交易输入框
    // width: 50%;
  }
}
.mb3 {
  margin-bottom: 3px;
}
div.enRealTimeTransCC .maintrans .title > li {
  width: auto;
}
.marketSelectBox {
  font-size: 16px;
  color: #1f3f59;
  position: relative;
  margin: 11px 10px;
  border: 1px solid #1b1d24;
  height: 80px;
  .bluePoint {
    position: absolute;
    display: none;
    font-size: 40px;
    line-height: 10px;
    color: blue;
    font-weight: bolder;
    left: 10px;
    top: 13px;
  }
  .redPoint {
    position: absolute;
    display: none;
    font-size: 40px;
    line-height: 10px;
    color: red;
    font-weight: bolder;
    left: 10px;
    bottom: 18px;
  }
  .from {
    position: absolute;
    display: inline-block;
    color: darkgray;
    line-height: 40px;
    left: 30px;
    top: 0;
  }
  .to {
    position: absolute;
    display: inline-block;
    color: darkgray;
    line-height: 40px;
    left: 30px;
    top: 40px;
  }
  .BBMarket {
    position: absolute;
    display: inline-block;
    color: #bfc3ce;
    line-height: 40px;
    top: 0;
    left: 75px;
    right: 68px;
    transition: top 0.2s;
  img {
      height: 20px;
      position: absolute;
      right: 0;
      top: 10px;
    }
  }
  .ListMarket {
    position: absolute;
    display: inline-block;
    color: #bfc3ce;
    line-height: 40px;
    bottom: 0;
    left: 75px;
    transition: top 0.2s;
  }
  .rightBox {
    position: absolute;
    display: table-cell;
    top: 0;
    right: 0;
    bottom: 0;
    width: 58px;
    text-align: center;
    vertical-align: middle;
    background: rgba(111, 142, 255, 0.5);
    // border-left: 1px solid #bfc3ce;
    img {
      width: 30px;
      height: 30px;
      margin-top: 25px;
    }
  }
  .lineBox {
    position: absolute;
    display: inline-block;
    right: 58px;
    top: 39.5px;
    height: 1px;
    background: rgba(111, 142, 255, 0.5);
    left: 20px;
  }
}
.inputMessagebox input {
  background: none;
  outline: none;
  text-indent: 10px;
  width: 100%;
  font-size: 14px;
  // color: #000;
  line-height: 40px;
  border: 1px solid #ddd;
}
</style>
<style scope lang="scss">
  ::v-deep .el-checkbox__inner:hover{
        border-color: #161719 !important;
  }
#exchanges .cotract{
 
  color: #EEEEEE;
  // text-align: center;
  .el-checkbox__input{
    .el-checkbox__inner:hover{
        border-color: #dfdfdf !important;
  }
  }
  .is-focus{
    .el-checkbox__inner{
        border-color: #dfdfdf !important;
  }
  }
  .is-checked{
     
      .el-checkbox__inner{
      background-color: #161719 !important;
      border-color: #fff !important;
    }
 
  }
  
}
#exchanges /deep/ .el-dialog {
  // background: rgba(38, 53, 98, 1) !important;
  height: auto !important;
}
// #exchanges /deep/  .el-dialog .el-dialog__header,#exchanges /deep/  .el-dialog .el-dialog__body,#exchanges /deep/ .el-dialog .el-dialog__footer{
//   background: rgba(38, 53, 98, 1) !important;
//   padding-top: 20px;
// }
// #exchanges /deep/  .el-dialog .el-dialog__header .el-dialog__title{
//   color: #000 !important;
// }
#exchanges /deep/ .el-button {
  background-color: #fff !important;
}
#exchanges /deep/ .el-button span {
  color: #409eff !important;
}
#exchanges /deep/ .el-button--primary {
  background-color: #409eff !important;
  border-color: #409eff !important;
  color: #fff !important;
}
#exchanges /deep/ .el-button--primary span {
  color: #fff !important;
}
.ctc-bi-btns /deep/ span {
  color: #fff;
}
.ctc-bi-btns {
  float: right;
}
.box .maintrans .content .left .btn {
  text-align: center;
}
.message_right {
  width: 19%;
  float: right;
  text-align: center;
  border: 1px solid #2382fa;
  border-radius: 2px;
  color: #2382fa;
}
.protol_top {
  display: flex;
  flex-direction: column;
  .pt_title {
    margin-bottom: 2vw;
    font-size: 1vw;
  }
  .dialog_footer {
    margin-bottom: 2vw;
    display: flex;
    justify-content: flex-end;
  }
}
.protol_bottom {
  .pb_title {
    text-align: center;
    margin-bottom: 30px;
  }
}
.message {
  .pricebtns,.numbtns {
    width: 25px;
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .pricebtn,.numbtn {
      font-size: 12px;
      cursor: pointer;
      color: #EEEEEE;
    }
  }
}

</style>
<style lang="scss">
#exchanges .topSelectChange {
  // height: 30px;
  // padding: 10px 0;
  box-sizing: border-box;
  .el-radio-group {
    display: felx;
    justify-content: space-between;
  }
  .el-radio {
    margin: 0 !important;
  }
  .el-radio__label{
    font-size: 12px;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #EEEEEE !important;
    font-size: 12px;
  }
}
</style>
